// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const arrowCellSize = "48px";
export const pageCellSize = "32px";
export const textCenter = "Paginator__textCenter__Y3u3V";
export const paginator = "Paginator__paginator__XilK2";
export const stretching = "Paginator__stretching__gMXD8";
export const cell = "Paginator__cell__zHvgs";
export const arrowInner = "Paginator__arrowInner__Deamv";
export const arrow = "Paginator__arrow__+KJw7";
export const disabled = "Paginator__disabled__vbO1a";
export const pages = "Paginator__pages__sUFhc";
export const ellipsis = "Paginator__ellipsis__Dq37C";
export const current = "Paginator__current__d2tEd";
export const page = "Paginator__page__BdLrk";